import Vue from 'vue';

export default {
  setData(state, { result, year }) {
    if (!Object.keys(state.data).includes(year)) {
      Vue.set(state.data, year, result);

      return;
    }

    state.data[year] = result;
  },

  setSepData(state, { items, year }) {
    if (!Object.keys(state.sepData).includes(year)) {
      Vue.set(state.sepData, year, items);

      return;
    }

    state.sepData[year] = items;
  },

  setYear(state, year) {
    state.year = year;
  },
};
